import { gql } from "../../../__generated__/gql";

export const GET_BAND = gql(`
query band($id: String!) {
  band (where: {id: $id}){
    id
    name
    description
    imageUrl
    showcase
    socials
    links
    genres
    buttons
    bookings {
      id
      announcement {
        id
        name
        editionId
        edition {
          id
          name
          timezone
        }
      }
      edition {
        id
        name
        timezone
      }
      startTime
      endTime
      stage {
        name
      }
    }
  }
}
`);

export const UPDATE_BAND = gql(`
mutation updateBand($id: String!, $name: String, $description: String, $imageUrl: String, $showcase: Boolean, $socials: JSON) {
  updateBand(band: { id: $id, name: $name, description: $description, imageUrl: $imageUrl, showcase: $showcase, socials: $socials }) {
    id
    name
    description
    imageUrl
    showcase
    socials
  }
}
`);

export const CREATE_UPDATE_BAND = gql(`
mutation createUpdateBand(
  $id: String
  $name: String
  $description: String
  $imageUrl: String
  $showcase: Boolean
  $socials: JSON
  $organisationId: String
  $genres: String
  $buttons: JSON
) {
  createUpdateBand(
    band: {
      id: $id
      name: $name
      description: $description
      imageUrl: $imageUrl
      showcase: $showcase
      socials: $socials
      organisationId: $organisationId
      genres: $genres
      buttons: $buttons
    }
  ) {
    id
    name
    description
    imageUrl
    showcase
    socials
    genres
    buttons
  }
}
`);

export const UPDATE_BAND_LINKS = gql(`
  mutation updateBandLinks($id: String!, $links: JSON) {
    updateBand(band: { id: $id, links: $links }) {
      id
      name
      description
      imageUrl
      showcase
      socials
      links
    }
  }
  `);

export const CREATE_BAND = gql(`
mutation ceateBand($name: String!, $description:String!, $organisationId: String!) {
  createBand(name: $name, description:$description,organisationId: $organisationId){
    id
  }
}
`);

export const ADD_IMAGE = gql(`
mutation addImage($image: String!){
  addImage(image: $image)
}
`);

export const DELETE_BAND = gql(`mutation deleteBand($bandId:String!) {
  deleteBand(bandId: $bandId){
    id
  }
}`);
